define('modules/start/products/sms/activity/view',['require','exports','module','env','views/BaseView','ldsh!./template'],function(require, exports, module) {
    "use strict";

    var Config = require("env");
    var BaseView = require("views/BaseView");

    var Layout = BaseView.extend({
        template: require("ldsh!./template"),
        serialize: function() {
            return {
                "deliveries": this.productsReport.get("sms_deliveries"),
                isAdm: this.isAdm
            };
        }
    });

    module.exports = Layout;
});
